import { HttpParams } from '@angular/common/http';
import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { WORK_SESSION_DEFINITION_BY_ID, WORK_SESSION_DEFINITIONS_V2 } from '../common/endpoints';
import { PagedList, WorkSessionDefinition } from '../model';
import { HttpService } from './http.service';

@Injectable()
export class WorkSessionDefinitionService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private http: HttpService
    ) { }

    getWorkSessionDefinitionsById(id: string): Promise<WorkSessionDefinition> {
        const endpoint = WORK_SESSION_DEFINITION_BY_ID.replace("{id}", id);
        return firstValueFrom(this.http.get<WorkSessionDefinition>(endpoint));
    }

    getRecursivelyAllWorkSessionDefinitions(page?: number, definitions?: WorkSessionDefinition[], params?: HttpParams): Promise<WorkSessionDefinition[]> {
        if (!page) {
            page = 0;
        }
        if (!definitions) {
            definitions = [];
        }
        return this.getPagedWorkSessionDefinitions(page, 100, ['name', 'asc'], params)
            .then(pagedMetrics => {
                definitions = definitions.concat(pagedMetrics.content);
                if (pagedMetrics.last) {
                    return definitions;
                } else {
                    return this.getRecursivelyAllWorkSessionDefinitions(++page, definitions);
                }
            });
    }

    getPagedWorkSessionDefinitions(page: number, size: number, sort: string[], params: HttpParams): Promise<PagedList<WorkSessionDefinition>> {
        if (!params) {
            params = new HttpParams();
        }
        params = params.set('page', page + '');
        params = params.set('size', size + '');
        params = params.set('sort', sort.join(','));
        return firstValueFrom(this.http.get<PagedList<WorkSessionDefinition>>(WORK_SESSION_DEFINITIONS_V2, params));
    }
}